import { render, staticRenderFns } from "./RegisterOnboardForm.vue?vue&type=template&id=6873f4c1&scoped=true&"
import script from "./RegisterOnboardForm.vue?vue&type=script&lang=js&"
export * from "./RegisterOnboardForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOnboardForm.vue?vue&type=style&index=0&id=6873f4c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6873f4c1",
  null
  
)

export default component.exports